export interface BlogArticle {
  slug: string;
  date: string;
  image: string;
  titleKey: string;
  excerptKey: string;
  metaTitleKey: string;
  metaDescKey: string;
  contentKey: string;
}

export const blogArticles: BlogArticle[] = [
  {
    slug: "chimichurri-oppskrift",
    date: "2026-04-05",
    image: "/blog-chimichurri.png",
    titleKey: "blog.chimichurri.title",
    excerptKey: "blog.chimichurri.excerpt",
    metaTitleKey: "blog.chimichurri.meta_title",
    metaDescKey: "blog.chimichurri.meta_desc",
    contentKey: "blog.chimichurri.content",
  },
  {
    slug: "open-fire-grill-funksjoner",
    date: "2026-04-07",
    image: "/open-fire-grill.jpg",
    titleKey: "blog.grillfunksjoner.title",
    excerptKey: "blog.grillfunksjoner.excerpt",
    metaTitleKey: "blog.grillfunksjoner.meta_title",
    metaDescKey: "blog.grillfunksjoner.meta_desc",
    contentKey: "blog.grillfunksjoner.content",
  },
  {
    slug: "vedlikehold-stalgrill",
    date: "2026-04-13",
    image: "/open-fire-grill.jpg",
    titleKey: "blog.vedlikehold.title",
    excerptKey: "blog.vedlikehold.excerpt",
    metaTitleKey: "blog.vedlikehold.meta_title",
    metaDescKey: "blog.vedlikehold.meta_desc",
    contentKey: "blog.vedlikehold.content",
  },
];
